import React, {createContext, useCallback, useContext, useMemo, useState} from "react";
import useToggle from "v4/hooks/useToggle";

const defaultValues = {
    quoteLinesMethods: null,
    setQuoteLinesMethods: () => {
    },
    checkCustomerEventService: false,
    toggleCheckCustomerEventService: () => {
    },
    reofferConfig: null,
    setReofferConfig: () => {
    },
    reofferOpenId: null,
    openReoffer: null,
    closeReoffer: () => {
    }
};

const QuoteTabContext = createContext(defaultValues);

export function useQuoteTabContext() {
    return useContext(QuoteTabContext);
}

export default function QuoteTabProvider({children}) {
    const [quoteLinesMethods, setQuoteLinesMethods] = useState(null);
    const [checkCustomerEventService, toggleCheckCustomerEventService] = useToggle();
    const [reofferConfig, setReofferConfig] = useState(null);
    const [reofferOpenId, setReofferOpenId] = useState(null);

    const openReoffer = useCallback((quoteId) => setReofferOpenId(quoteId), []);
    const closeReoffer = useCallback(() => setReofferOpenId(null), []);

    const returnValue = useMemo(() => ({
        quoteLinesMethods,
        setQuoteLinesMethods,
        checkCustomerEventService,
        toggleCheckCustomerEventService,
        reofferConfig,
        setReofferConfig,
        reofferOpenId,
        openReoffer,
        closeReoffer
    }), [quoteLinesMethods, setQuoteLinesMethods, checkCustomerEventService, toggleCheckCustomerEventService, reofferConfig, reofferOpenId, openReoffer, closeReoffer]);

    return (
        <QuoteTabContext.Provider value={returnValue}>
            {children}
        </QuoteTabContext.Provider>
    )
}
